module.exports = __webpack_public_path__ + "img/ic_no_notification.964dcb89.svg";